export default __webpack_public_path__ + "static/img72h-78ccca5fd439b97023a6f51fd5e200ca.jpg";